import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = { class: "card-title" }

import {MenuComponent} from "@/assets/ts/components";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import ApiService from "@/core/services/ApiService";
import {ElMessage} from 'element-plus';
import Overview from "./components/Overview.vue";
import PieDigram from "./components/PieDigram.vue";
import BarDigram from "./components/BarDigram.vue";
import Filter from "./components/CategoryFilter.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const apiUrl = 'report/category';
const filters = reactive({});
const loading = ref<boolean>(false);
const chartData = reactive({
  'cat_name': {title: '类目分布', data: [], report_id: 8, indicator: [], loading: false},
  'is_new': {title: '新老品', data: [], report_id: 19, indicator: [], loading: false},
  'goods_sale_type': {title: '商品销量分层', data: [], report_id: 20, indicator: [], loading: false},
})

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("report.product.categoryOverview", ["report.product.name", "report.product.categoryName"]);

  for (let k in chartData) {
    ApiService.get('report/category/indicator', {report_id: chartData[k]['report_id']}).then(({data}) => {
      if (data.length < 1) {
        ElMessage.error('基础数据不足，请与管理员联系！');
      } else {
        chartData[k]['indicator'] = [];
        for (let i of data) {
          if (i.is_display == 1) {
            chartData[k]['indicator'].push(i);
          }
        }
      }
    });
  }
});

// 搜索动作
const searchAction = (filter) => {
  for (let k in filter) {
    filters[k] = filter[k];
  }
  loading.value = true;
  for (let k in chartData) {
    chartData[k]['loading'] = true;
    ApiService.get(apiUrl + '/summary/?report_id=' + chartData[k]['report_id'] + '&dimension=' + k, filters).then(({data}) => {
      chartData[k]['data'] = [...data];
      chartData[k]['loading'] = false;
      loading.value = false;
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Filter, { onSearchAction: searchAction }),
    _createVNode(Overview, {
      title: "同期对比",
      "api-url": apiUrl + '/overview',
      filters: _unref(filters),
      loading: loading.value
    }, null, 8, ["api-url", "filters", "loading"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chartData), (val, key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "card mb-5 mb-xl-10"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(val.title), 1)
        ]),
        _createElementVNode("div", null, [
          _withDirectives((_openBlock(), _createBlock(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val.indicator, (v, i) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  key: i,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createVNode(PieDigram, {
                      title: v.name,
                      dimension: key,
                      field: v.field,
                      data: val.data
                    }, null, 8, ["title", "dimension", "field", "data"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024)), [
            [_directive_loading, val.loading]
          ])
        ])
      ]))
    }), 128)),
    _createVNode(BarDigram, {
      apiUrl: 'report/price',
      filters: _unref(filters),
      loading: loading.value
    }, null, 8, ["filters", "loading"])
  ], 64))
}
}

})